/* Arflonia Produktkarten v3 · eine Karten-Vorlage · Schnell-Hinzufügen · Mini-Warenkorb (2 Sek.) · Marken-Karussell */
(function () {
  'use strict';
  if (window.__arfCards3) return; window.__arfCards3 = 1;
  var D = document, W = window, H = D.documentElement;
  H.classList.add('arf-cfit');
  var ROOT = (W.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var LABEL = 'In den Warenkorb', TH = 4900, KG = 30;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: (W.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format((c || 0) / 100); } catch (e) { return ((c || 0) / 100).toFixed(2).replace('.', ',') + ' €'; } }
  var onCart = /^\/cart\/?$/.test(location.pathname);

  /* ---------- Produkt im Bild auf einheitliche Fläche skalieren ---------- */
  var cv = null;
  function analyze(img) {
    var key = img.currentSrc || img.src;
    if (img.__fitKey === key) return img.__fit;
    var nw = img.naturalWidth, nh = img.naturalHeight; if (!nw || !nh) return null;
    img.__fitKey = key;
    var S = 72, w = nw >= nh ? S : Math.max(8, Math.round(S * nw / nh)), h = nh > nw ? S : Math.max(8, Math.round(S * nh / nw)), d;
    cv = cv || D.createElement('canvas'); cv.width = w; cv.height = h;
    var cx = cv.getContext('2d', { willReadFrequently: true });
    try { cx.clearRect(0, 0, w, h); cx.drawImage(img, 0, 0, w, h); d = cx.getImageData(0, 0, w, h).data; } catch (e) { return (img.__fit = null); }
    function px(x, y) { var i = (y * w + x) * 4; return [d[i], d[i + 1], d[i + 2], d[i + 3]]; }
    var cs = [px(0, 0), px(w - 1, 0), px(0, h - 1), px(w - 1, h - 1), px(w >> 1, 0), px(w >> 1, h - 1)];
    var tr = cs.every(function (c) { return c[3] < 30; }), bg = [0, 0, 0];
    if (!tr) {
      cs.forEach(function (c) { bg[0] += c[0] / 6; bg[1] += c[1] / 6; bg[2] += c[2] / 6; });
      var sp = 0; cs.forEach(function (c) { sp = Math.max(sp, Math.abs(c[0] - bg[0]) + Math.abs(c[1] - bg[1]) + Math.abs(c[2] - bg[2])); });
      if (sp > 70) return (img.__fit = { photo: 1 });
    }
    var x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
      var i = (y * w + x) * 4, on = tr ? d[i + 3] > 40 : d[i + 3] > 40 && (Math.abs(d[i] - bg[0]) + Math.abs(d[i + 1] - bg[1]) + Math.abs(d[i + 2] - bg[2])) > 46;
      if (on) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    }
    if (x1 < 0) return (img.__fit = null);
    var b = { x: x0 / w, y: y0 / h, w: (x1 - x0 + 1) / w, h: (y1 - y0 + 1) / h };
    if (b.w > 0.97 && b.h > 0.97) b.full = 1;
    return (img.__fit = b);
  }
  W.arfAnalyze = analyze;
  function fitImg(img) {
    var box = img.closest('[data-fit]'); if (!box) return;
    var F = parseFloat(box.getAttribute('data-fit')) || 0.8, b = analyze(img);
    img.classList.add('is-fit');
    if (!b || b.photo || b.full) { img.style.transform = 'none'; img.style.setProperty('--arf-fit', 'none'); return; }
    var FW = img.clientWidth, FH = img.clientHeight; if (!FW || !FH) return;
    var tf = fitTf(img, F, b, FW, FH);
    img.style.transform = tf; img.style.setProperty('--arf-fit', tf);
  }
  function fitTf(img, F, b, FW, FH) {
    var ar = img.naturalWidth / img.naturalHeight, rw, rh;
    if (FW / FH > ar) { rh = FH; rw = FH * ar; } else { rw = FW; rh = FW / ar; }
    var s = Math.max(0.5, Math.min(2.2, Math.min(F * FW / (rw * b.w), F * FH / (rh * b.h))));
    var dx = (b.x + b.w / 2 - 0.5) * rw, dy = (b.y + b.h / 2 - 0.5) * rh;
    return 'translate(' + (-s * dx / FW * 100).toFixed(2) + '%,' + (-s * dy / FH * 100).toFixed(2) + '%) scale(' + s.toFixed(3) + ')';
  }
  /* 2026-10-28 Claude: Tempo – geladene Bilder werden pro Frame gesammelt angepasst:
     erst alle Bilder analysieren, dann alle Größen lesen, dann alle Transformationen schreiben
     (vorher eine Layout-Neuberechnung pro Bild). Ergebnis identisch. */
  var fitQ = [], fitT = 0;
  function queueFit(img) {
    if (fitQ.indexOf(img) < 0) fitQ.push(img);
    if (!fitT) fitT = W.requestAnimationFrame ? W.requestAnimationFrame(flushFit) : setTimeout(flushFit, 16);
  }
  function flushFit() {
    fitT = 0;
    var q = fitQ, jobs = [];
    fitQ = [];
    q.forEach(function (img) {
      try {
        var box = img.closest('[data-fit]'); if (!box) return;
        var F = parseFloat(box.getAttribute('data-fit')) || 0.8, b = analyze(img);
        img.classList.add('is-fit');
        jobs.push({ img: img, F: F, b: b });
      } catch (e) { img.classList.add('is-fit'); }
    });
    jobs.forEach(function (j) { if (j.b && !j.b.photo && !j.b.full) { j.FW = j.img.clientWidth; j.FH = j.img.clientHeight; } });
    jobs.forEach(function (j) {
      try {
        var img = j.img, b = j.b;
        if (!b || b.photo || b.full) { img.style.transform = 'none'; img.style.setProperty('--arf-fit', 'none'); return; }
        if (!j.FW || !j.FH) return;
        var tf = fitTf(img, j.F, b, j.FW, j.FH);
        img.style.transform = tf; img.style.setProperty('--arf-fit', tf);
      } catch (e) { j.img.classList.add('is-fit'); }
    });
  }
  var bound = [];
  function bindFit(img) {
    if (img.__fitBound) return; img.__fitBound = 1; bound.push(img);
    var run = function () { queueFit(img); };
    img.addEventListener('load', run);
    img.addEventListener('error', function () { img.classList.add('is-fit'); });
    if (img.complete && img.naturalWidth) run(); else if (img.complete) img.classList.add('is-fit');
    setTimeout(function () { img.classList.add('is-fit'); }, 4000);
  }
  W.arfFit = function (scope) { Array.prototype.forEach.call((scope || D).querySelectorAll('[data-fit] img'), bindFit); };
  var rz;
  W.addEventListener('resize', function () {
    clearTimeout(rz);
    rz = setTimeout(function () { bound.forEach(function (im) { if (im.isConnected && im.classList.contains('is-fit')) { try { fitImg(im); } catch (e) {} } }); }, 200);
  });

  function euro(s) { return String(s).replace(/€\s?([\d.]+,\d{2})/g, '$1 €'); }

  /* ---------- Startseiten-Leisten im Vorlagen-Look ---------- */
  function enhance(scope) {
    Array.prototype.forEach.call((scope || D).querySelectorAll('.arflonia-rail .arflonia-product:not([data-arf-c3])'), function (card) {
      card.setAttribute('data-arf-c3', '1');
      var t = card.querySelector('.arflonia-product__title');
      if (t) {
        var st = t.querySelector('strong'), brand = st ? st.textContent.trim() : '';
        var title = t.textContent.replace(/\s+/g, ' ').trim();
        if (brand && title.indexOf(brand) === 0) title = title.slice(brand.length).trim();
        title = title.replace(/\s*\|\s*[^|]+$/, '').trim();
        t.innerHTML = (brand ? '<strong>' + esc(brand) + '</strong> ' : '') + esc(title || brand);
      }
      var p = card.querySelector('.arflonia-product__price:not(.arflonia-product__price--deal)');
      if (p) p.innerHTML = euro(p.innerHTML);
      var old = card.querySelector('.arflonia-price-old s'); if (old) old.textContent = euro(old.textContent);
      var wrap = card.querySelector('.arflonia-product__image-wrap');
      if (wrap) { wrap.setAttribute('data-fit', '0.8'); var im = wrap.querySelector(':scope > img'); if (im) bindFit(im); }
      var cta = card.querySelector('.arflonia-product__cta');
      if (cta && cta.querySelector('.arflonia-product__cta-plus')) {
        cta.setAttribute('data-arf-qa', ''); cta.setAttribute('role', 'button');
        cta.setAttribute('aria-label', (title || 'Produkt') + ' in den Warenkorb legen');
        cta.textContent = LABEL;
      }
    });
  }

  /* ---------- Mini-Warenkorb „Im Warenkorb“ ---------- */
  var Mini = (function () {
    var el, timer, hold = false, T = 3000;
    var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
    var X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    function build() {
      if (el) return el;
      el = D.createElement('div');
      el.className = 'arf-mini'; el.hidden = true;
      el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
      el.innerHTML = '<div class="arf-mini__h"><span class="arf-mini__ok">' + CHECK + '</span><b>Im Warenkorb</b><button type="button" class="arf-mini__x" data-arf-mini-x aria-label="Schließen">' + X + '</button></div>' +
        '<div class="arf-mini__item"><span class="arf-mini__img" data-m-img></span><span class="arf-mini__txt"><b data-m-t></b><small data-m-v></small></span><b class="arf-mini__sum" data-m-sum></b></div>' +
        '<div class="arf-mini__ship" data-m-ship hidden><span data-m-shipt></span><span class="arf-mini__bar"><i data-m-bar></i></span></div>' +
        '<div class="arf-mini__a"><a class="arf-mini__go" href="' + ROOT + 'cart">Zum Warenkorb <span data-m-c></span></a><button type="button" class="arf-mini__more" data-arf-mini-x>Weiter einkaufen</button></div>' +
        '<span class="arf-mini__timer" aria-hidden="true"><i></i></span>';
      D.body.appendChild(el);
      el.style.setProperty('--t', (T / 1000) + 's');
      el.addEventListener('click', function (e) { if (e.target.closest('[data-arf-mini-x]')) close(); });
      el.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'mouse') return; hold = true; el.classList.add('is-hold'); clearTimeout(timer); });
      el.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'mouse') return; hold = false; el.classList.remove('is-hold'); clearTimeout(timer); timer = setTimeout(close, 1200); });
      D.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      return el;
    }
    function q(s) { return el.querySelector(s); }
    function place() {
      if (!W.matchMedia('(min-width: 750px)').matches) { el.style.top = ''; return; }
      var top = 20;
      Array.prototype.forEach.call(D.querySelectorAll('.shopify-section-group-header-group, header'), function (h) {
        var r = h.getBoundingClientRect(); if (r.height && r.top < 240 && r.bottom > 0 && r.bottom + 12 > top) top = r.bottom + 12;
      });
      el.style.top = Math.min(top, 240) + 'px';
    }
    /* Warenkorb-Stand vorab merken → Versand-Leiste + Anzahl erscheinen sofort mit dem Mini-Warenkorb */
    var CART = null; try { var _cs = JSON.parse(W.sessionStorage.getItem('arf-cart-sum') || 'null'); if (_cs && typeof _cs.t === 'number') CART = _cs; } catch (e) {}
    function prefetch() { fetch(ROOT + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) { if (c) { CART = { t: c.total_price || 0, n: c.item_count || 0, w: c.total_weight || 0 }; try { W.sessionStorage.setItem('arf-cart-sum', JSON.stringify(CART)); } catch (e) {} } }).catch(function () {}); }
    if (W.requestIdleCallback) W.requestIdleCallback(prefetch, { timeout: 2500 }); else setTimeout(prefetch, 1200);
    function show(info) {
      build();
      var img = info.img ? String(info.img).replace(/([?&])width=\d+/, '$1width=160') : '';
      q('[data-m-img]').innerHTML = img ? '<img src="' + esc(img) + '" alt="">' : '';
      q('[data-m-t]').textContent = info.title || '';
      q('[data-m-v]').textContent = (info.variant && !/default title/i.test(info.variant) ? info.variant + ' · ' : '') + 'Menge ' + (info.qty || 1);
      q('[data-m-sum]').textContent = info.line != null ? money(info.line) : '';
      if (CART) { update({ total_price: CART.t + (+info.line || 0), item_count: CART.n + (+info.qty || 1), total_weight: CART.w }); }
      else { q('[data-m-c]').textContent = ''; q('[data-m-ship]').hidden = true; prefetch(); }
      place();
      el.hidden = false; el.classList.remove('is-in');
      void el.offsetWidth;
      requestAnimationFrame(function () { el.classList.add('is-in'); });
      clearTimeout(timer); if (!hold) timer = setTimeout(close, T);
    }
    function update(c) {
      if (c) { CART = { t: c.total_price || 0, n: c.item_count || 0, w: c.total_weight || 0 }; try { W.sessionStorage.setItem('arf-cart-sum', JSON.stringify(CART)); } catch (e) {} }
      if (!el || !c) return;
      q('[data-m-c]').textContent = c.item_count ? '(' + c.item_count + ')' : '';
      var total = c.total_price || 0, over = (c.total_weight || 0) > KG * 1000, left = TH - total, free = left <= 0 && !over;
      var box = q('[data-m-ship]');
      box.hidden = false; /* über 30 kg: Hinweis statt Fortschritt – kostenloser Versand gilt bis 30 kg (wie auf der Produktseite) */ box.classList.toggle('is-free', free); box.classList.toggle('is-over', over);
      q('[data-m-shipt]').innerHTML = free ? '<b>Kostenloser Versand</b> für deine Bestellung' : over ? 'Über <b>' + KG + ' kg</b> – Versandkosten im Warenkorb' : 'Noch <b>' + esc(money(left)) + '</b> bis zum kostenlosen Versand';
      q('[data-m-bar]').style.width = (over ? 100 : Math.max(4, Math.min(100, total / TH * 100))) + '%';
    }
    function close() {
      if (!el || el.hidden) return;
      clearTimeout(timer); el.classList.remove('is-in', 'is-hold'); hold = false;
      setTimeout(function () { if (!el.classList.contains('is-in')) el.hidden = true; }, 260);
    }
    return { show: show, update: update, close: close };
  })();
  W.ArfMini = Mini;

  function counts() { return Array.prototype.slice.call(D.querySelectorAll('.pets-desktop-cart-count,.pets-mobile-cart-count,[data-cart-count]')); }
  function setCounts(n) { counts().forEach(function (el) { el.textContent = n; el.classList.toggle('is-empty', n < 1); }); }
  function getCart() { return fetch(ROOT + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }); }

  /* Handy: Button nach „Hinzugefügt“ sofort wieder im Normalzustand – iPhone hält sonst den Tipp-Zustand fest, bis man woanders tippt */
  function releaseTap(btn) {
    try {
      if (!(W.matchMedia && W.matchMedia('(hover: none)').matches)) return;
      btn.classList.add('arf-tap-reset');
      var p = btn.parentNode, nx = btn.nextSibling;
      if (p) { p.removeChild(btn); p.insertBefore(btn, nx); }
      setTimeout(function () { btn.classList.remove('arf-tap-reset'); }, 350);
    } catch (e) {}
  }

  /* Schnell-Hinzufügen: sofort grün „Hinzugefügt“, Mini-Warenkorb öffnet im selben Moment */
  function quickAdd(btn, card, variantPromise, info) {
    if (btn.dataset.arfBusy) return;
    btn.dataset.arfBusy = '1';
    var label = btn.getAttribute('data-label') || LABEL; btn.setAttribute('data-label', label);
    btn.textContent = 'Hinzugefügt';
    btn.classList.add('arf-is-added');
    var tLeave = setTimeout(function () { if (btn.dataset.arfBusy) btn.classList.add('arf-is-leaving'); }, 1000);
    var tOk = setTimeout(function () { if (btn.dataset.arfBusy) { btn.textContent = label; btn.classList.remove('arf-is-added', 'arf-is-leaving'); btn.classList.add('arf-is-back'); setTimeout(function () { btn.classList.remove('arf-is-back'); }, 450); delete btn.dataset.arfBusy; try { btn.blur(); } catch (e) {} releaseTap(btn); } }, 1200);
    var cs = counts(), before = cs.map(function (el) { return parseInt(el.textContent, 10) || 0; });
    cs.forEach(function (el, i) { el.textContent = before[i] + 1; el.classList.remove('is-empty'); });
    if (!onCart) Mini.show(info);
    variantPromise.then(function (id) {
      if (!id) throw new Error('na');
      return fetch(ROOT + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) });
    }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function (res) {
        D.dispatchEvent(new CustomEvent('arf:cart:added', { bubbles: true, detail: { items: res.items || [res], arfMini: 1 } }));
        D.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return getCart();
      }).then(function (c) { setCounts(c.item_count); Mini.update(c); })
      .catch(function () {
        cs.forEach(function (el, i) { el.textContent = before[i]; el.classList.toggle('is-empty', before[i] < 1); });
        Mini.close(); clearTimeout(tOk); clearTimeout(tLeave); btn.classList.remove('arf-is-added', 'arf-is-leaving'); btn.textContent = label; delete btn.dataset.arfBusy;
        var a = card && card.querySelector('a[href*="/products/"]'); if (a) location.href = a.href;
      });
  }
  function cardInfo(card, titleSel, priceSel) {
    var t = card.querySelector(titleSel), im = card.querySelector('img');
    var pn = card.querySelector(priceSel), pt = pn ? pn.textContent.replace(/\s+/g, ' ') : '';
    var m = pt.match(/(\d{1,3}(?:\.\d{3})*),(\d{2})/), cents = m ? parseInt(m[1].replace(/\./g, ''), 10) * 100 + parseInt(m[2], 10) : null;
    return { title: t ? t.textContent.replace(/\s+/g, ' ').trim() : '', img: im ? (im.currentSrc || im.src) : '', qty: 1, line: cents };
  }
  D.addEventListener('click', function (e) {
    var b = e.target.closest('[data-akc-add], [data-akc-h], .arflonia-rail .arflonia-product__cta[data-arf-qa]');
    if (!b || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    if (b.closest('.ac')) return; /* Warenkorb-Seite hat eine eigene Logik */
    e.preventDefault(); e.stopPropagation();
    var card = b.closest('.akc, .arflonia-product');
    if (b.hasAttribute('data-akc-add')) {
      quickAdd(b, card, Promise.resolve(+b.getAttribute('data-akc-add')), cardInfo(card, '.akc__t', '.akc__p'));
    } else if (b.hasAttribute('data-akc-h')) {
      /* ältere „Zuletzt angesehen“-Einträge: erst prüfen, ob es nur eine Variante gibt */
      if (b.dataset.arfBusy) return;
      var h = b.getAttribute('data-akc-h'), go = function (u) { location.href = u || ROOT + 'products/' + h; };
      b.dataset.arfBusy = '1'; b.setAttribute('aria-busy', 'true');
      fetch(ROOT + 'products/' + h + '.js').then(function (r) { return r.json(); }).then(function (p) {
        var all = p.variants || [], av = all.filter(function (x) { return x.available; });
        delete b.dataset.arfBusy; b.removeAttribute('aria-busy');
        if (all.length === 1 && av.length === 1) {
          b.removeAttribute('data-akc-h'); b.setAttribute('data-akc-add', av[0].id);
          quickAdd(b, card, Promise.resolve(av[0].id), cardInfo(card, '.akc__t', '.akc__p'));
        } else go(p.url);
      }).catch(function () { go(); });
    } else {
      var m = (b.getAttribute('href') || '').match(/\/products\/([^/?#]+)/); if (!m) return;
      var vp = fetch(ROOT + 'products/' + m[1] + '.js').then(function (r) { return r.json(); }).then(function (p) { var v = (p.variants || []).filter(function (x) { return x.available; })[0]; return v && v.id; });
      quickAdd(b, card, vp, cardInfo(card, '.arflonia-product__title', '.arflonia-product__price'));
    }
  }, true);

  /* Kategorie-/Abteilungsseiten melden „hinzugefügt“ → Mini-Warenkorb zeigen */
  D.addEventListener('arf:cart:added', function (e) {
    var d = e.detail; if (!d || d.arfMini || onCart) return;
    var it = (d.items && d.items[0]) || d; if (!it || !it.id) return;
    Mini.show({ title: (it.product_title || it.title || '').split(' | ')[0], variant: it.variant_title, img: it.image || (it.featured_image && it.featured_image.url), qty: it.quantity || 1, line: it.final_line_price != null ? it.final_line_price : it.line_price });
    getCart().then(Mini.update).catch(function () {});
  });

  /* ---------- Marken-Karussell: Tippen öffnet die Markenseite, Ziehen bewegt nur ---------- */
  var bx = null;
  D.addEventListener('pointerdown', function (e) {
    var a = e.target.closest && e.target.closest('a.abrands__item');
    bx = a && !(e.pointerType === 'mouse' && e.button !== 0) ? { a: a, x: e.clientX, y: e.clientY, t: Date.now() } : null;
  }, true);
  D.addEventListener('pointerup', function (e) {
    var b = bx; bx = null; if (!b) return;
    if (Math.abs(e.clientX - b.x) > 8 || Math.abs(e.clientY - b.y) > 8 || Date.now() - b.t > 800) { b.a.__drag = Date.now(); return; }
    b.a.__nav = Date.now();
    if (e.ctrlKey || e.metaKey || e.shiftKey) W.open(b.a.href, '_blank'); else W.location.href = b.a.href;
  }, true);
  D.addEventListener('pointercancel', function () { bx = null; }, true);
  D.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.abrands__item'); if (!a) return;
    var now = Date.now();
    if ((a.__drag && now - a.__drag < 500) || (a.__nav && now - a.__nav < 500)) e.preventDefault();
  }, true);

  function run() { enhance(D); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', run); else run();
  if ('MutationObserver' in W) {
    /* 2026-11-05 Claude: nur nachlaufen, wenn neue Elemente dazukommen – nicht bei reinen Text-Änderungen
       (der Black-Friday-Countdown tickt jede Sekunde; vorher lief enhance() dadurch jede Sekunde über die ganze Seite). */
    var t, SKIP = /^(SCRIPT|STYLE|LINK|META|NOSCRIPT|IFRAME|BR|TEMPLATE)$/;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var a = muts[i].addedNodes;
        for (var j = 0; j < a.length; j++) { if (a[j].nodeType === 1 && !SKIP.test(a[j].nodeName)) { clearTimeout(t); t = setTimeout(run, 120); return; } }
      }
    }).observe(D.documentElement, { childList: true, subtree: true });
  }
})();

/* ---------- Werbe-Kacheln in den Startseiten-Reihen: Breite passt sich dem Motiv an (kein abgeschnittener Text) ---------- */
(function (W, D) {
  if (W.__arfPromoFit) return; W.__arfPromoFit = 1;
  var tiles = [];
  /* Motivbild der Kachel – nicht die kleinen Hund/Katze-Symbole in den Buttons */
  function pimg(p) { var a = p.querySelectorAll('.arflonia-promo__artwork img'); for (var i = 0; i < a.length; i++) { if (!a[i].closest('.arf-pk')) return a[i]; } return null; }
  function fit(p) {
    if (!p.offsetParent) return;
    var im = pimg(p); if (!im || !im.naturalWidth) return;
    var r = im.naturalWidth / im.naturalHeight, vw = W.innerWidth, row = p.parentElement, rw = row ? row.clientWidth : vw;
    if (vw < 750) return; /* Handy: Kachel hat bereits das passende Format */
    var min = 220, max = rw * (vw < 1100 ? 0.52 : 0.45);
    /* Höhe der Reihe hängt von der Kartenbreite ab → bis zur stabilen Breite nachrechnen */
    for (var k = 0; k < 5; k++) {
      var h = p.getBoundingClientRect().height; if (!h) return;
      var w = Math.round(Math.max(min, Math.min(max, h * r)));
      if (Math.abs((parseFloat(p.style.width) || p.getBoundingClientRect().width) - w) < 2) return;
      p.style.setProperty('flex', '0 0 ' + w + 'px', 'important');
      p.style.setProperty('width', w + 'px', 'important');
      p.style.setProperty('max-width', 'none', 'important');
    }
  }
  function all() { tiles.forEach(fit); }
  function init() {
    tiles = [].slice.call(D.querySelectorAll('.arflonia-rail .arflonia-promo'));
    if (!tiles.length) return;
    tiles.forEach(function (p) {
      var im = pimg(p); if (!im) return;
      if (p.offsetParent && im.loading === 'lazy') im.loading = 'eager';
      im.addEventListener('load', function () { fit(p); });
    });
    all();
    if ('ResizeObserver' in W) { var ro = new ResizeObserver(all); tiles.forEach(function (p) { if (p.parentElement) ro.observe(p.parentElement); }); }
    var t; W.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(all, 120); }, { passive: true });
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
})(window, document);
